import MyDropzone from "./MyDropzone";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { useUserInfo } from "../../context/user";
import "./style.css";
import DropboxChooser from "../ThirdPartyServices/DropboxChooser";
import env from "../../config/env";
import SelectAssistant from "./SelectAssistant";
import GoogleDrivePickers from "../ThirdPartyServices/GoogleDrivePickers";
import OneDrivePicker from "../ThirdPartyServices/OneDrivePicker";
import toast from "react-hot-toast";
import { useAgentsList } from "../../queries/agents";
import { useMediaLibraryFiles } from "../../queries/knowledgeBase";
import { Upload, CloudUpload } from "lucide-react";
import { Button } from "components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "components/ui/dropdown-menu";

const GoogleDriveIcon = ({ className }) => (
  <svg viewBox="0 0 87.3 78" className={className} aria-hidden>
    <path d="m6.6 66.85 3.85 6.65c.8 1.4 1.95 2.5 3.3 3.3l13.75-23.8h-27.5c0 1.55.4 3.1 1.2 4.5z" fill="#0066da" />
    <path d="m43.65 25-13.75-23.8c-1.35.8-2.5 1.9-3.3 3.3l-25.4 44a9.06 9.06 0 0 0 -1.2 4.5h27.5z" fill="#00ac47" />
    <path d="m73.55 76.8c1.35-.8 2.5-1.9 3.3-3.3l1.6-2.75 7.65-13.25c.8-1.4 1.2-2.95 1.2-4.5h-27.502l5.852 11.5z" fill="#ea4335" />
    <path d="m43.65 25 13.75-23.8c-1.35-.8-2.9-1.2-4.5-1.2h-18.5c-1.6 0-3.15.45-4.5 1.2z" fill="#00832d" />
    <path d="m59.8 53h-32.3l-13.75 23.8c1.35.8 2.9 1.2 4.5 1.2h50.8c1.6 0 3.15-.45 4.5-1.2z" fill="#2684fc" />
    <path d="m73.4 26.5-12.7-22c-.8-1.4-1.95-2.5-3.3-3.3l-13.75 23.8 16.15 28h27.45c0-1.55-.4-3.1-1.2-4.5z" fill="#ffba00" />
  </svg>
);

const DropboxIcon = ({ className }) => (
  <svg viewBox="0 0 24 24" className={className} aria-hidden fill="#0061FF">
    <path d="M6 2 0 6l6 4 6-4zm12 0-6 4 6 4 6-4zM0 14l6 4 6-4-6-4zm18-4-6 4 6 4 6-4zM6 19l6 4 6-4-6-4z" />
  </svg>
);

function Index({ classname, refreshchat, compType = "knowledge_base", isSharedKnowledge = false }) {
  const BASE_URL = env.API_URL + "/v1";
  const [alertModel, setAlertModel] = useState(false);
  const userInfo = useUserInfo()[0];
  const userActiveLocation = useUserInfo()[4];
  const user = useUserInfo()[0];
  const checkIfGhlUser = useUserInfo()[9];
  const contextuploadFilefrominput = useUserInfo()[16];
  const [toggleOption, setToggleOption] = useState(false);
  const [openAssistantModal, setOpenAssistantModal] = useState(false);
  const [openMediaAssistantModal, setOpenMediaAssistantModal] = useState(false);
  const [thirdPartFiles, setThirdPartyFiles] = useState([]);
  const [thirdPartyInitialFiles, setThirdPartyInitialFiles] = useState(null);
  const [spinnerLoading, setSpinnerLoading] = useState(false);
  const [disabled, setDisabled] = useState(false);
  const [mediaLibraryModel, setMediaLibraryModel] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [mediaLibraryData, setMediaLibraryData] = useState([]);
  const [convertedFiles, setConvertedFiles] = useState([]);
  const [tempSelectedFiles, setTempSelectedFiles] = useState([]);
  const [searchMediaTerm, setSearchMediaTerm] = useState("");
  const [optionSelect, setOptionSelect] = useState("");
  const [crahsfileMessage, setcrahsfileMessage] = useState([]);
  const [uploadSummary, setUploadSummary] = useState({ docs: 0, agents: 0 });
  const [uploadProgress, setUploadProgress] = useState(null);
  const [uploadDone, setUploadDone] = useState(null);

  const alertModelRef = useRef(false);
  const eventSourceRef = useRef(null);


  const agentCount = (assistant) =>
    Array.isArray(assistant) ? assistant.length : assistant ? 1 : 0;

  const filesReadyMessage = (docs, agents, failed) => {
    if (failed > 0) {
      const ok = docs - failed;
      return `${ok} document${ok === 1 ? "" : "s"} added. ${failed} file${failed === 1 ? "" : "s"} could not be processed.`;
    }
    return isSharedKnowledge
      ? `${docs} file${docs === 1 ? "" : "s"} ${docs === 1 ? "is" : "are"} now available in the shared knowledge base.`
      : `${docs} file${docs === 1 ? "" : "s"} ${docs === 1 ? "is" : "are"} now available to ${agents} Agent${agents === 1 ? "" : "s"}.`;
  };

  useEffect(() => {
    alertModelRef.current = alertModel;
  }, [alertModel]);


  const closeUploadModal = () => {
    setAlertModel(false);
    setUploadDone(null);
    setUploadProgress(null);
    setThirdPartyInitialFiles(null);
  };

  useEffect(() => {
    return () => eventSourceRef.current?.close();
  }, []);



  const streamUploadProgress = async (jobs = []) => {
    const results = [];

    for (const job of jobs) {
      const result = await new Promise((resolve) => {
        const userId = user?._id || "";

        const source = new EventSource(
          `${BASE_URL}/chat/assistants/files/upload-progress?jobId=${job.jobId}&userId=${encodeURIComponent(userId)}&isStreaming=true`
        );

        const crashfiles = [];

        source.addEventListener("file-done", (e) => {
          const data = JSON.parse(e.data);
          if (data.status === "done") {
            toast.success(`${data.fileName} uploaded successfully . Indexing in progress…

              `);
            refreshchat();
          } else if (data.status === "failed") {
            toast.error(`${data.fileName} upload failed`);
            crashfiles.push(data.fileName);
          }
        });

        source.addEventListener("done", (e) => {
          source.close();
          const data = JSON.parse(e.data);
          resolve({
            jobId: job.jobId,
            fileName: job.fileName,
            success: data.status === "completed",
            crashfiles: data.crashfiles || crashfiles,
          });
        });

        source.addEventListener("error", () => {
          source.close();
          resolve({
            jobId: job.jobId,
            fileName: job.fileName,
            success: false,
            crashfiles,
          });
        });
      });

      results.push(result);
    }

    return results;
  };

  const filteredMediaLibraryData = mediaLibraryData?.filter((item) =>
    item.name.toLowerCase().includes(searchMediaTerm.toLowerCase()),
  );

  const handleMediaAssistantOpen = () => {
    setMediaLibraryModel(false);
    setOpenMediaAssistantModal(true);
    setOptionSelect("mediaLibrary");
  };

  const handleCloseModal = () => {
    setMediaLibraryModel(false); // Close the modal
    setSearchMediaTerm(""); // Clear the search term
  };

  const handleAction = () => {
    setDisabled(true);
    setTimeout(() => setDisabled(false), 3000); // Disable for 3 seconds
  };

  // Was a raw axios.get(`${BASE_URL}/assistant/fetchbyuser...`) fired once on
  // mount via useEffect(..., []); now backed by the shared useAgentsList query
  // (also used by usersContext.js, ApiAccess/index.js, integration/index.js
  // and addwebsites/index.js) so a write on the Agents page invalidates this
  // dropdown too. selectionData is purely derived: [] while loading (matching
  // the original useState([]) initializer), [initalAssistant] on error, else
  // the raw status-filtered list (no Brand AI prepend on success, matching
  // the original success branch exactly).
  const { data: agentsFetchData, isError: agentsFetchError } = useAgentsList(userInfo._id, userActiveLocation?.id);

  const selectionData = useMemo(() => {
    if (agentsFetchError) {
      const initalAssistant = {
        assistant_name: "Brand AI",
        modal_name: "openai/gpt-4o",
        assistant_id: userActiveLocation?.assistant_id,
        status: true,
      };
      return [initalAssistant].filter((item) => item.status);
    }
    return (agentsFetchData?.data || []).filter((item) => item.status);
  }, [agentsFetchData, agentsFetchError, userActiveLocation?.assistant_id]);

  const mediaLibraryFilesMutation = useMediaLibraryFiles();
  const getMediaFiles = async () => {
    try {
      const response = await mediaLibraryFilesMutation.mutateAsync(userActiveLocation.id);
      if (response) {
        const files = response?.data?.files;

        // Set the media library data
        setMediaLibraryData(files);

        // Process and convert files
        const downloadedFiles = await downloadFiles(
          files?.map((file) => ({
            url: file.url,
            name: file.name,
            mimeType: file.contentType, // Assuming contentType corresponds to mimeType
          })),
        );

        // Store converted files in state
        setConvertedFiles(downloadedFiles);
      }
    } catch (error) {
      console.error("Error fetching media files:", error);
    }
  };

  // Helper function to download and convert files
  const downloadFiles = async (files) => {
    return Promise.all(
      files?.map(async (file) => {
        try {
          const response = await fetch(file.url);
          const blob = await response.blob();
          return new File([blob], file.name, { type: file.mimeType });
        } catch (error) {
          console.error("Error downloading file:", error);
          return null;
        }
      }),
    ).then((results) => results.filter(Boolean));
  };

  useEffect(() => {
    getMediaFiles();
  }, []);

  const handleFileSelect = (file) => {
    setTempSelectedFiles((prev) => {
      const isAlreadySelected = prev.some(
        (selectedFile) => selectedFile.id === file.id,
      );
      if (isAlreadySelected) {
        // Remove the file if already selected
        return prev.filter((selectedFile) => selectedFile.id !== file.id);
      }
      // Add the file if not selected
      return [...prev, file];
    });
  };

  const handleDoneClick = async (assistant, setLoader) => {
    var response = await contextuploadFilefrominput(
      convertedFiles,
      userActiveLocation?.id,
      user?.userName,
      assistant,
      compType,
    );
    if (response.data.data[0].success) {
      setMediaLibraryModel(false);
      setTempSelectedFiles([]);
      setOpenAssistantModal(false);
      setAlertModel(false);
      setOpenMediaAssistantModal(false);
      toast.success("File(s) uploaded");
      setLoader(false);
      refreshchat();
    }
    if (response?.data?.crashfiles?.length > 0) {
      setAlertModel(false);
      toast.error(
        `Some files failed to upload (token limit may be exceeded): ${response.data.crashfiles
          .map((f) => f?.name || f)
          .join(", ")}`,
      );
    }
  };

  const isUploadSuccess = (response) =>
    isSharedKnowledge
      ? response?.data?.success
      : response?.data?.data?.[0]?.success;

  // Pull the real failure reason. Agent uploads can return a top-level
  // success:true while the per-file result (data[0]) actually failed, so the
  // inner error/message takes priority over the misleading top-level message.
  const getUploadErrorMessage = (response) => {
    const item = response?.data?.data?.[0];
    return (
      item?.error ||
      item?.message ||
      response?.data?.message ||
      response?.message ||
      "File upload failed. Please try again."
    );
  };

  const saveDropzoneFiles = async (files, assistant) => {
    var response = await contextuploadFilefrominput(
      files,
      userActiveLocation?.id,
      user?.userName,
      assistant,
      compType,
    );

    if (isUploadSuccess(response)) {
      setMediaLibraryModel(false);
      setAlertModel(false);
      toast.success("File(s) uploaded");
      refreshchat();
    } else if (response?.data?.crashfiles?.length > 0) {
      setAlertModel(false);
      toast.error(
        `Some files failed to upload (token limit may be exceeded): ${response.data.crashfiles
          .map((f) => f?.name || f)
          .join(", ")}`,
      );
    } else {
      // Upload failed (e.g. 503) — close the modal and notify the user.
      setAlertModel(false);
      toast.error(getUploadErrorMessage(response));
    }
  };

  const saveThirdPartyFiles = async (assistant, setLoader, filesOverride) => {
    var response = await contextuploadFilefrominput(
      filesOverride || thirdPartFiles,
      userActiveLocation?.id,
      user?.userName,
      assistant,
      compType,
    );
    setToggleOption(false);
    if (isUploadSuccess(response)) {
      setOpenAssistantModal(false);
      toast.success("File(s) uploaded");
      setLoader?.(false);
      refreshchat();
    }
    if (response?.data?.crashfiles?.length > 0) {
      setAlertModel(false);
      toast.error(
        `Some files failed to upload (token limit may be exceeded): ${response.data.crashfiles
          .map((f) => f?.name || f)
          .join(", ")}`,
      );
    }
  };

  const isImageFile = (file) => {
    const mime = (file?.type || file?.mimeType || "").toLowerCase();
    if (mime.startsWith("image/")) return true;
    const name = (file?.name || "").toLowerCase();
    return /\.(jpe?g|png|gif|webp|bmp|svg|tiff?|heic|heif|ico)$/i.test(name);
  };

  const files_recieved_from_child = async (files, type) => {
    const incoming = Array.isArray(files) ? files : [];
    const filtered = incoming.filter((f) => !isImageFile(f));
    const removedCount = incoming.length - filtered.length;
    if (removedCount > 0) {
      alert("Image files are not allowed and have been skipped.");
    }
    if (filtered.length === 0) return;

    setThirdPartyFiles(filtered);
    // Route Google Drive / Dropbox files through the same MyDropzone modal used
    // by "Upload From Computer" so third-party uploads get the identical
    // experience. MyDropzone adapts to the context: Agent Knowledge shows the
    // Assign-Agents step, Shared Knowledge skips straight to processing.
    setUploadDone(null);
    setUploadProgress(null);
    setcrahsfileMessage([]);
    setThirdPartyInitialFiles(filtered);
    setAlertModel(true);
    setToggleOption(false);
  };

  const handleRemoveThirdPartyFile = (index) => {
    setThirdPartyFiles((prev) => {
      const updated = prev.filter((_, i) => i !== index);
      // Close the modal automatically if no files remain
      if (updated.length === 0) {
        setOpenAssistantModal(false);
      }
      return updated;
    });
  };

  return (
    <>
      {/* alerts */}
      {alertModel && (
        <>
          <div className="modal-zz" onClick={() => setAlertModel(false)}>
            <div
              className="modal-content-zz position-relative"
              onClick={(e) => e.stopPropagation()}
            >
              <MyDropzone
                saveDropzoneFiles={saveDropzoneFiles}
                selectionData={selectionData}
                isSharedKnowledge={isSharedKnowledge}
                onClose={closeUploadModal}
                uploadProgress={uploadProgress}
                uploadDone={uploadDone}
                initialFiles={thirdPartyInitialFiles}
              />
            </div>
          </div>
        </>
      )}


      <DropdownMenu
        open={toggleOption}
        onOpenChange={(open) => {
          setToggleOption(open);
          if (open) handleAction();
        }}
      >
        <DropdownMenuTrigger asChild>
          <Button variant="outline" className="h-9 gap-2 text-sm rounded-md">
            <Upload className="h-4 w-4" /> Upload
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end" className="w-64 p-1.5">
          <DropdownMenuItem className="gap-3 py-2.5 px-2 cursor-pointer">
            <GoogleDriveIcon className="h-5 w-5 shrink-0" />
            <GoogleDrivePickers
              disabled={disabled}
              files_send_to_parent={files_recieved_from_child}
              setSpinnerLoading={setSpinnerLoading}
            />
          </DropdownMenuItem>
          <DropdownMenuItem className="gap-3 py-2.5 px-2 cursor-pointer">
            <DropboxIcon className="h-5 w-5 shrink-0" />
            <DropboxChooser
              disabled={disabled}
              files_send_to_parent={files_recieved_from_child}
              setSpinnerLoading={setSpinnerLoading}
            />
          </DropdownMenuItem>
          <DropdownMenuSeparator />
          <DropdownMenuItem
            className="gap-3 py-2.5 px-2 cursor-pointer"
            onSelect={() => {
              // Clear any leftover state from a previous upload so the modal
              // always opens on the fresh "Upload files" screen instead of a
              // stale "Files Ready" summary.
              setUploadDone(null);
              setUploadProgress(null);
              setcrahsfileMessage([]);
              setThirdPartyInitialFiles(null);
              setAlertModel(true);
            }}
          >
            <CloudUpload className="h-5 w-5 shrink-0 text-foreground" />
            Upload From Computer
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>

      {openAssistantModal && (
        <>
          <div className="modal-zz">
            <div
              className="modal-content-zz position-relative"
              onClick={(e) => e.stopPropagation()}
            >
              <p
                style={{
                  position: "absolute",
                  right: 5,
                  width: "12px",
                  top: "10px",
                  height: "12px",
                  cursor: "pointer",
                }}
                onClick={() => setOpenAssistantModal(false)}
              >
                X
              </p>

              <SelectAssistant
                optionSelect={optionSelect}
                saveThirdPartyFiles={saveThirdPartyFiles}
                handleDoneClick={handleDoneClick}
                selectionData={selectionData}
                onClose={() => setOpenAssistantModal(false)}
              />
            </div>
          </div>
        </>
      )}

      {openMediaAssistantModal && (
        <>
          <div className="modal-zz">
            <div
              className="modal-content-zz position-relative"
              onClick={(e) => e.stopPropagation()}
            >
              <p
                style={{
                  position: "absolute",
                  right: 5,
                  width: "12px",
                  top: "10px",
                  height: "12px",
                  cursor: "pointer",
                }}
                onClick={() => setOpenMediaAssistantModal(false)}
              >
                X
              </p>

              <SelectAssistant
                optionSelect={optionSelect}
                saveThirdPartyFiles={saveThirdPartyFiles}
                handleDoneClick={handleDoneClick}
                selectionData={selectionData}
                onClose={() => setOpenMediaAssistantModal(false)}
              />
            </div>
          </div>
        </>
      )}

      {mediaLibraryModel && (
        <div className="select_file_modal" onClick={handleCloseModal}>
          <div
            className="select_file_modal_content"
            onClick={(e) => e.stopPropagation()}
          >
            <p
              style={{
                position: "absolute",
                right: 10,
                width: "12px",
                top: "10px",
                height: "12px",
                cursor: "pointer",
              }}
              onClick={handleCloseModal}
            >
              X
            </p>

            <div
              style={{
                marginBottom: "34px",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <b className="text_black">Select a file</b>

              <input
                type="search"
                placeholder="Search"
                style={{
                  outline: "1px solid hsl(var(--border))",
                  borderRadius: "5px",
                  width: "50%",
                  padding: "10px",
                }}
                value={searchMediaTerm}
                onChange={(e) => setSearchMediaTerm(e.target.value)}
              />
            </div>

            <div style={{ maxHeight: "350px", overflow: "auto" }}>
              <div className="v3_modal_table_heading">
                <p>File Name</p>
                <p style={{ textAlign: "center" }}>Date created</p>
                <p></p>
              </div>

              <div>
                {filteredMediaLibraryData?.length > 0 ? (
                  filteredMediaLibraryData?.map((item, index) => (
                    <div className="v3_modal_table_body" key={index}>
                      <p>
                        {item.name.length > 15
                          ? item.name.slice(0, 15) + "..."
                          : item.name}
                      </p>
                      <p style={{ textAlign: "center" }}>
                        {new Date(item.createdAt).toLocaleDateString("en-GB", {
                          day: "2-digit",
                          month: "2-digit",
                          year: "numeric",
                        })}
                      </p>
                      <div className="v3_modal_table_body_input">
                        <input
                          type="checkbox"
                          style={{ cursor: "pointer" }}
                          onChange={() => handleFileSelect(item)}
                          checked={tempSelectedFiles.some(
                            (selectedFile) => selectedFile.id === item.id,
                          )}
                        />
                      </div>
                    </div>
                  ))
                ) : (
                  <p style={{ alignItems: "center", display: "flex" }}>
                    No files found
                  </p>
                )}
              </div>
            </div>

            <button
              className="v3_modal_table_button"
              onClick={handleMediaAssistantOpen}
            >
              Done
            </button>
          </div>
        </div>
      )}
    </>
  );
}

export default Index;
